<template>
  <div class="shuttleFrame">
    <div class="shuttleFrame-top jy-form-container">
      <div class="top-left">
        <el-form :model="searchForm">
          <el-row :gutter="gutter">
            <template v-for="(item, index) in searchData" >
              <el-col :span="6" :key="index" v-show="item.type !== 'hidden'" style="height: 63px;">
                <el-form-item
                    class="jy-form-input"
                    :label="item.title"
                    :label-width="item.labelWidth"
                    v-if="item.type === 'disabled'"
                    disabled
                >
                  <el-input disabled v-model="searchForm[item.key]"></el-input>
                </el-form-item>
                <el-form-item
                    class="jy-form-select"
                    :label="item.title"
                    :label-width="item.labelWidth"
                    v-else-if="item.type === 'select'"
                >
                  <el-select v-model="searchForm[item.key]" :placeholder="item.placeholder" clearable>
                    <el-option
                        v-for="value in item.options"
                        :key="value.value"
                        :label="value.label"
                        :value="value.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                    class="jy-form-select"
                    :label="item.title"
                    :label-width="item.labelWidth"
                    v-else-if="item.type === 'ajax'"
                >
                  <el-select v-model="searchForm[item.key]" :placeholder="item.placeholder" clearable @visible-change="visibleChange($event, item)">
                    <el-option
                        v-for="value in item.options"
                        :key="value.value"
                        :label="value[item.parms.label]"
                        :value="value[item.parms.value]"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="jy-form-select" label="费项类型" label-width="80" v-else-if="item.type === 'itemCategory'">
                  <el-select v-model="searchForm.itemCategoryId" :placeholder="item.placeholder" clearable @visible-change="visibleChange($event, item)">
                    <el-option
                        v-for="value in item.options"
                        :key="value.value"
                        :label="value[item.parms.label]"
                        :value="value[item.parms.value]"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="jy-form-select" label="费项" label-width="80" v-else-if="item.type === 'itemService'">
                  <el-select v-model="searchForm[item.key]" :placeholder="item.placeholder" clearable @visible-change="visibleChangeItemService($event, item)">
                    <el-option
                        v-for="value in item.options"
                        :key="value.value"
                        :label="value[item.parms.label]"
                        :value="value[item.parms.value]"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="jy-form-input" label="客户名称" label-width="80" v-else-if="item.type === 'userMemberName'">
                  <el-input v-model="searchForm.userMemberName" clearable placeholder="选择客户" class="teshu-append" disabled>
                    <template slot="append" v-if="pageStatus !== 'readonly'">
                      <span style="color: blue" @click="onSelectCustomer">选择</span>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item class="jy-form-time" :label="item.title" :label-width="item.labelWidth" v-else-if="item.type === 'datetime'">
                  <el-date-picker
                      v-model="searchForm[item.key]"
                      value-format="YYYY-MM-dd HH:mm:ss"
                      type="datetime"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item class="jy-form-input" :label-width="item.labelWidth" :label="item.title" v-else>
                  <el-input v-model="searchForm[item.key]" clearable :placeholder="item.placeholder"></el-input>
                </el-form-item>
              </el-col>
            </template>
          </el-row>
        </el-form>
      </div>
      <div class="top-right">
        <el-button type="primary" @click="onSearch">查询</el-button>
        <el-button @click="onReset">重置</el-button>
      </div>
    </div>
    <div class="shuttleFrame-box">
      <div class="box-left">
        <div class="title-box">可选择</div>
        <el-table
            :height="tableHeight"
            :data="leftData"
            style="width: 100%"
            @selection-change="leftSelectionChange"
            ref="multipleTableRef"
            class="jy-common-table"
            stripe
        >
          <el-table-column label="序号" align="center" type="index" width="80" fixed></el-table-column>
          <el-table-column align="center" type="selection" width="55" fixed></el-table-column>
          <template v-for="(item, index) in tableHead" >
            <el-table-column
                v-if="item.isShow"
                show-overflow-tooltip
                align="center"
                :key="index"
                :prop="item.name"
                :label="item.label"
                :width="item.width"
            ></el-table-column>
          </template>
        </el-table>
        <div class="page-box">
          <el-pagination
              class="system-page"
              @current-change="leftPageChange"
              background
              layout="total,prev,pager,next"
              :total="leftPageData.total"
              :page-size="leftPageData.size"
              :pager-count="5"
              v-model="leftPageData.page"
          ></el-pagination>
        </div>
      </div>
      <div class="box-content">
        <el-button
            type="primary"
            icon="el-icon-arrow-right"
            circle
            :disabled="rightDiabled"
            @click="toRightTable"
            style="margin-bottom: 20px; width: 50px; height: 50px; font-size: 20px"
        ></el-button>
        <el-button
            type="primary"
            icon="el-icon-arrow-left"
            :disabled="leftDiabled"
            @click="toLeftTable"
            circle
            style="margin-left: 0; width: 50px; height: 50px; font-size: 20px"
        ></el-button>
      </div>
      <div class="box-right">
        <div class="title-box">已选择</div>
        <el-table
            :height="tableHeight"
            :data="rightData"
            style="width: 100%"
            @selection-change="rightSelectionChange"
            ref="multipleTableRef"
            class="jy-common-table"
            stripe
        >
          <el-table-column label="序号" align="center" type="index" width="80" fixed></el-table-column>
          <el-table-column align="center" type="selection" width="55" fixed></el-table-column>
          <template v-for="(item, index) in tableHead">
            <el-table-column
                v-if="item.isShow"
                show-overflow-tooltip
                align="center"
                :key="index"
                :prop="item.name"
                :label="item.label"
                :width="item.width"
            ></el-table-column>
          </template>
        </el-table>
        <div class="page-box">
          <el-pagination
              class="system-page"
              background
              @current-change="rightPageChange"
              layout="total,prev,pager,next"
              :total="rightSearchList.length"
              :page-size="7"
              v-model="rightCurrentPage"
              :pager-count="5"
          ></el-pagination>
        </div>
      </div>
    </div>
    <selectCustomers
        :show="selectCustomersStatus"
        :data="queryData"
        @onCancelSelectCustomers="onCancelSelectCustomers"
        @onConfirmSelectCustomers="onConfirmSelectCustomers"
    ></selectCustomers>
  </div>
</template>

<script>
import selectCustomers from "@/components/selectCustomers/index.vue";
import { Api } from "@/assets/js/api";
import utils from "@/assets/js/tool";
export default {
  name: "ShuttleFrame",
  components: {
    selectCustomers
  },
  props: {
    searchData: {
      type: Array,
      default: () => []
    },
    searchResult: {
      type: Object,
      default: () => ({})
    },
    tableHead: {
      type: Array,
      default: () => []
    },
    tableHeight: {
      type: [String, Number],
      default: 380
    },
    tableLeftData: {
      type: Array,
      default: () => []
    },
    leftPageData: {
      type: Object,
      default: () => ({})
    },
    filterData: {
      type: Array,
      default: () => []
    },
    pageStatus: {
      type: String,
      default: 'create'
    },
  },
  data() {
    return {
      gutter: 20,
      searchForm: {},
      selectData: [],
      rightCurrentPage: 1,
      rightSearchList: [],
      leftDiabled: true,
      leftTableSele: [],
      rightDiabled: true,
      rightTableSele: [],
      selectCustomersStatus: false,
      queryData: [],
    };
  },
  computed: {
    leftData() {
      return this.tableLeftData.filter(item => !this.selectData.includes(item.id));
    },
    rightData() {
      const start = (this.rightCurrentPage - 1) * 7;
      const end = start + 7;
      return this.rightSearchList.slice(start, end);
    },
  },
  watch: {
    searchResult: {
      handler(newVal) {
        console.log("searchResult", newVal);
        this.searchForm = JSON.parse(JSON.stringify(newVal));
      },
      deep: true,
      immediate: true
    },
    filterData: {
      handler(newVal) {
        this.selectData = JSON.parse(JSON.stringify(newVal));
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onSearch() {
      this.$emit("getSearch", this.searchForm);
    },
    onReset() {
      this.searchForm = {};
    },
    leftPageChange(val) {
      this.$emit("leftPageChange", val);
    },
    rightPageChange(val) {
      this.rightCurrentPage = val;
    },
    leftSelectionChange(val) {
      this.rightDiabled = !Boolean(val.length);
      this.leftTableSele = val;
    },
    rightSelectionChange(val) {
      this.leftDiabled = !Boolean(val.length);
      this.rightTableSele = val;
    },
    toRightTable() {
      let isError = false;
      if (this.leftTableSele.length < 1) {
        this.$message({ message: "至少选择一条数据" });
        isError = true;
        return;
      }
      this.leftTableSele.forEach(item => {
        if (!item.id) {
          this.$message({ message: "所选数据不符合条件,无法添加" });
          isError = true;
          return;
        }
      });
      if (!isError) {
        // this.rightSearchList.push(...this.leftTableSele);
        // 只添加不存在的数据
        const existingIds = this.rightSearchList.map(item => item.id);
        const newItems = this.leftTableSele.filter(item => !existingIds.includes(item.id));
        this.rightSearchList.push(...newItems);
        this.rightSearchList.forEach(item => {
          if (!this.selectData.includes(item.id)) {
            this.selectData.push(item.id);
          }
        });
        this.$emit("filterTable", this.rightSearchList);
      }
    },
    toLeftTable() {
      if (this.rightTableSele.length < 1) {
        this.$message({ message: "至少选择一条数据" });
        return;
      }
      const oldTotal = this.rightSearchList.length;
      this.rightSearchList = this.difference(this.rightSearchList, this.rightTableSele);
      const newTotal = this.rightTableSele.length;
      if (oldTotal % 50 === 1 && newTotal < oldTotal) {
        this.rightCurrentPage -= 1;
      }
      this.rightTableSele.forEach(item => {
        this.selectData = this.selectData.filter(data => data !== item.id);
      });
      this.$emit("filterTable", this.rightSearchList);
    },
    difference(arr1, arr2) {
      if (!Array.isArray(arr1) || !Array.isArray(arr2)) return [];
      const a = JSON.parse(JSON.stringify(arr1));
      const b = JSON.parse(JSON.stringify(arr2));
      const s = new Set(b.map(JSON.stringify));
      return a.filter(x => !s.has(JSON.stringify(x)));
    },
    onSelectCustomer() {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中...",
        background: "rgba(255, 255, 255, 0)"
      });
      const reqNumber = "member_down_list";
      Api.getReportConditions({ number: reqNumber }).then(res => {
        if (res.status === 200 && res.data.status === "success") {
          const result = res.data.result || [];
          result.forEach(value => {
            if (value.conditonKey === "nickname") {
              value.rules = [{ required: true, message: "必填", trigger: "blur" }];
            }
          });
          if (utils.jyCheckObjectType(result) === "Array") {
            this.queryData = result;
          }
          this.selectCustomersStatus = true;
        }
        loading.close();
      });
    },
    onCancelSelectCustomers() {
      this.selectCustomersStatus = false;
    },
    onConfirmSelectCustomers(data) {
      if (utils.jyCheckObjectType(data) === "Object") {
        this.searchForm.userMemberName = data.userMemberName;
        this.searchForm.userMemberId = data.userMemberId;
      }
      this.selectCustomersStatus = false;
    },
    visibleChange(val, item) {
      if (item.ajaxType === 1) {
        utils.getSelectData(item.ajaxParms, item.ajaxType).then(res => {
          item.options = res.arr;
        });
      }
    },
    visibleChangeItemService(val, item) {
      const qArr = [{ conditonKey: "itemCategoryId", conditonVal: this.searchForm.itemCategoryId }];
      if (item.ajaxType === 1) {
        utils.getSelectData(item.ajaxParms, item.ajaxType, qArr).then(res => {
          item.options = res.arr;
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/common.scss";

.shuttleFrame-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  .top-left {
    padding-right: 10px;
    flex: 1;
  }
  .top-right {
    width: 200px;
    min-width: 200px;
    display: flex;
    justify-content: flex-end;
  }
}
.shuttleFrame-box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .box-left {
    width: 535px;
    border: 1px solid #ccc;
  }
  .box-content {
    width: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .box-right {
    width: 535px;
    border: 1px solid #ccc;
  }
}
.title-box {
  padding: 10px;
  background: #fbfbfb;
  color: #000;
  font-weight: bold;
}
.page-box {
  height: 50px;
  display: flex;
  align-items: center;
  padding-left: 15px;
}

::v-deep .jy-form-input ,
::v-deep .jy-form-time ,
::v-deep .jy-form-select  {
  display: flex !important;
  width: 100% !important;
  line-height: 40px !important;
}
::v-deep .jy-form-input .el-form-item__label ,
::v-deep .jy-form-time .el-form-item__label,
::v-deep .jy-form-select .el-form-item__label {
  min-width: 100px !important;
  line-height: 40px !important;
  height: 40px !important;
  text-align: right !important; // 靠右对齐
}
</style>
